var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "location" }, [
    _c("div", { staticClass: "location__map" }, [
      _c("div", { staticClass: "location__btns" }, [
        _vm.model.AudioUrl != ""
          ? _c("a", { staticClass: "location__button button" }, [
              _c("img", { attrs: { src: "/public/img/volume.svg", alt: "" } }),
              _vm._v("Download Audio Guide"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.model.PDFUrl != ""
          ? _c("a", { staticClass: "location__button button" }, [
              _c("img", { attrs: { src: "/public/img/pdf.svg" } }),
              _vm._v("Download Route PDF"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.model.GPXUrl != ""
          ? _c("a", { staticClass: "location__button button" }, [
              _c("img", { attrs: { src: "/public/img/route.svg" } }),
              _vm._v("Download Route GPX"),
            ])
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "location__sidebar" }, [
      _c("h2", { staticClass: "location__title title" }, [
        _vm._v(_vm._s(_vm.model.Name)),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "location__options" }, [
        _c("li", [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "location__text" }, [
            _vm._v(_vm._s(_vm.model.Difficulty)),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "location__text" }, [
            _vm._v(_vm._s(_vm.model.Duration)),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "location__text" }, [
            _vm._v(_vm._s(Math.round(_vm.model.Elevation)) + " M"),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "location__text" }, [
            _vm._v(_vm._s(Math.round(_vm.model.Distance / 1000)) + " KM"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "ol",
        { staticClass: "location__list" },
        _vm._l(_vm.model.POIs, function (item) {
          return _c("li", { class: { active: item.Selected } }, [
            _c("div", { staticClass: "location__subtitle" }, [
              _vm._v(_vm._s(item.Title)),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "location__content",
              domProps: { innerHTML: _vm._s(item.Description) },
            }),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location__icon" }, [
      _c("img", { attrs: { src: "/public/img/route.svg", alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location__icon" }, [
      _c("img", { attrs: { src: "/public/img/clock.svg", alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location__icon" }, [
      _c("img", { attrs: { src: "/public/img/mountains.svg", alt: "" } }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "location__icon" }, [
      _c("img", { attrs: { src: "/public/img/distance.svg", alt: "" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }